import React from 'react'
import classnames from 'classnames';
import PhotoPreview from '../PhotoPreview';
import "./styles.scss";

const component = ({images, buttonText, onImgClick, onCtaClick }) =>
  <div className='image-track'>
    <div className='image-track__images'>
      {images.map((img, index) => {
        const imgSrc = img.preview || img.src;
        const imgClass = classnames(
          "image-track__image-preview",
          (img.variants || []).map(variant => `image-track__image-preview--${variant}`)
        );

        return onImgClick ?
          <PhotoPreview
            photo={{
              preview: imgSrc,
              alt: img.alt
            }}
            className={imgClass}
            key={imgSrc}
            variants={["fixed-height", "simple-overlay"]}
            onClick={() => onImgClick(index, img)}
            onKeyPress={() => onImgClick(index, img)} /> :

            <img
              className={imgClass}
              key={imgSrc}
              src={imgSrc}
              alt={img.alt || ""}
              />
      })}
    </div>

    <div className='image-track__cta'>
      <a tabIndex="0" className="button" onClick={onCtaClick} onKeyPress={onCtaClick}>
        {buttonText || `View All ${images.length} Photos`}
      </a>
    </div>
  </div>

component.displayName = 'ImageTrack';
export default component;


// WEBPACK FOOTER //
// ./client/components/ImageTrack/index.js